"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18n_configuration_provider_1 = require("@amzn/i18n.configuration-provider");
const offline_config_manager_holder_1 = __importDefault(require("./offline-config-manager-holder"));
const OfflineClientSettings_1 = __importDefault(require("@amzn/amazon-config-store-type-script-offline-adapter/dist/OfflineClientSettings"));
const ClientStage_1 = __importDefault(require("@amzn/amazon-config-store-model-tscommon/dist/utils/ClientStage"));
const DEFAULT_ACS_INPUT = 'ANY';
/**
 * Base class to resolve ACS offline queries.
 */
class OfflineQueryResolver extends i18n_configuration_provider_1.QueryResolver {
    getOfflineClientSettings() {
        return new OfflineClientSettings_1.default({
            stage: ClientStage_1.default.PROD
        });
    }
    createAcsClient(typeSafeClientProvider) {
        return offline_config_manager_holder_1.default.get().createClient(typeSafeClientProvider, { load: () => (this.getOfflineConfigFiles()) }, this.getOfflineClientSettings());
    }
    /**
     * Initializes the Query Resolver by loading the ACS offline configuration data
     * into memory.
     *
     * @return true if initialization succeeded, false otherwise
     */
    initialize() {
        if (!this.isInitialized()) {
            try {
                this._acsClient = this.createAcsClient(this.getTypeSafeClientProvider());
                this.setInitializedState(true);
            }
            catch (error) {
                console.log(`Failed to initialize Query Resolver ${this.constructor.name} with error ${error}`);
            }
        }
        return this.isInitialized();
    }
    createAcsContextInput(input) {
        return input === undefined ? DEFAULT_ACS_INPUT : input;
    }
    get acsClient() {
        return this._acsClient;
    }
    logAcsQuery(attributeName, input, output) {
        console.log(`Raw ACS query for attribute ${attributeName.constructor.name}. Input: ${input}, output: ${output}`);
    }
}
exports.default = OfflineQueryResolver;
//# sourceMappingURL=offline-query-resolver.js.map